import { OauthLoginProvider } from 'multirpc-sdk';

import { OAuthData } from '../types';

// by agreement with backend team this key is used in hash for telegram secret code
export const TELEGRAM_CODE_KEY = 'tgAuthResult';

// query params this module reads from the oauth callback URL; exported so the
// cleanup util removes exactly what is consumed here (single source of truth)
export const OAUTH_QUERY_PARAMS = ['code', 'state', 'error', 'provider'];

export const getOAuthDataFromURL = (): OAuthData => {
  const url = new URL(window.location.href);
  const error = url.searchParams.get('error') as OAuthData['error'];

  // for telegram params for auth url are not available and code is passed over the hash param
  const hashParams = new URLSearchParams(window.location.hash.slice(1));
  const tgAuthResult = hashParams.get(TELEGRAM_CODE_KEY);

  if (tgAuthResult) {
    return {
      code: tgAuthResult,
      error,
      provider: OauthLoginProvider.Telegram,
      state: 'default',
    };
  }

  // by default provider is set to Google as we don't receive it from urlParams
  let provider: OauthLoginProvider = OauthLoginProvider.Google;
  const state = url.searchParams.get('state');

  const providerFromUrlParams = url.searchParams.get(
    'provider',
  ) as OauthLoginProvider;

  if (providerFromUrlParams) {
    // if provider is defined in params - use it as provider
    provider = providerFromUrlParams;
    // for microsoft provider is defined in state param
  } else if (state === OauthLoginProvider.Microsoft) {
    provider = OauthLoginProvider.Microsoft;
  }

  return {
    code: url.searchParams.get('code'),
    error,
    provider,
    state,
  };
};
